import Button from "../../student/components/generic/button";
import { LtiConfigurationPayload } from "./Integration13";

type Props = {
  data: LtiConfigurationPayload;
  changePageState: () => void;
};

const ViewIntegrationData = (props: Props) => {
  return (
    <div className="flex max-w-lg flex-col gap-4">
      <div>
        <label
          htmlFor="issuer"
          className="block text-sm font-bold text-dm-charcoal-800"
        >
          Issuer
        </label>
        <div className="mt-1 flex flex-col gap-1">{props.data.issuer}</div>
      </div>
      <div>
        <label
          htmlFor="clientId"
          className="block text-sm font-bold text-dm-charcoal-800"
        >
          Client ID
        </label>
        <div className="mt-1">{props.data.clientId}</div>
      </div>
      <div>
        <label
          htmlFor="deploymentId"
          className="block text-sm font-bold text-dm-charcoal-800"
        >
          Deployment ID
        </label>
        <div className="mt-1">{props.data.deploymentId}</div>
      </div>
      <Button className="mt-6 w-full" onClick={props.changePageState}>
        Edit Integration
      </Button>
    </div>
  );
};

export default ViewIntegrationData;
